import events from '@layers/web/constants/events.ts'

const HAS_TRACKED_USER_CONSENT_LOCAL_STORAGE_KEY = 'hasTrackedUserConsent'

/**
 * Send user consent to the api to store for stats
 */
export default defineNuxtPlugin((nuxtApp) => {
  callAfterDocumentIdle(() => {
    const { ENVIRONMENT, market } = nuxtApp.$config.public
    if (ENVIRONMENT !== 'production') {
      return
    }

    let hasTrackedUserConsent
    try {
      hasTrackedUserConsent = window.localStorage.getItem(HAS_TRACKED_USER_CONSENT_LOCAL_STORAGE_KEY)
    } catch (e) {
      console.error('Could not get has tracked user consent status', e)
      return
    }

    if (hasTrackedUserConsent) {
      return
    }

    const trackUserConsent = async () => {
      window.removeEventListener(events.rbcsChange, trackUserConsent)

      try {
        await apiFetch(
          `/${market}/track-consent-preferences`,
          {
            method: 'POST',
            body: {
              adStorage: !!window.userConsent.advertising,
              adUserData: !!window.userConsent.advertising,
              adPersonalization: !!window.userConsent.advertising,
              analyticsStorage: !!window.userConsent.performance,
            },
          }
        )
        window.localStorage.setItem(HAS_TRACKED_USER_CONSENT_LOCAL_STORAGE_KEY, '1')
      } catch (e) {
        console.error('Failed tracking user consent', e)
      }
    }

    if (window.userConsent) {
      trackUserConsent()
      return
    }

    window.addEventListener(events.rbcsChange, trackUserConsent)
  }, 2000)
})